import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ThreatLog = () => (
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.38008 8.94054H17.4634C18.1351 8.94054 18.6767 8.39854 18.6767 7.72645V5.54759C18.6767 4.8755 18.1351 4.3335 17.4634 4.3335H3.38008C2.70841 4.3335 2.16675 4.8755 2.16675 5.54759V7.71561C2.16675 8.3877 2.70841 8.9297 3.38008 8.9297V8.94054ZM3.52091 5.68851H17.3334V7.58553H3.52091V5.68851ZM22.6198 10.6968H8.53649C7.86483 10.6968 7.32316 11.2388 7.32316 11.9109V14.0789C7.32316 14.751 7.86483 15.293 8.53649 15.293H22.6198C23.2915 15.293 23.8332 14.751 23.8332 14.0789V11.9109C23.8332 11.2388 23.2915 10.6968 22.6198 10.6968ZM22.479 13.9488H8.66649V12.0518H22.479V13.9488ZM3.38008 17.0706H17.4634C18.1351 17.0706 18.6767 17.6126 18.6767 18.2847V20.4527C18.6767 21.1248 18.1351 21.6668 17.4634 21.6668H3.38008C2.70841 21.6668 2.16675 21.1248 2.16675 20.4527V18.2847C2.16675 17.6126 2.70841 17.0706 3.38008 17.0706ZM3.52091 20.3227H17.3334V18.4256H3.52091V20.3227Z"
    />
  </svg>
)

export default withDefaultStyles(ThreatLog)
